"use strict";

require("core-js/modules/es6.string.small");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var baseFont = tslib_1.__importStar(require("./base"));

var fonts_1 = require("../fonts");

exports.large = tslib_1.__assign({}, baseFont.large, {
  fontFamily: fonts_1.mono
});
exports.base = tslib_1.__assign({}, baseFont.base, {
  fontFamily: fonts_1.mono
});
exports.small = tslib_1.__assign({}, baseFont.small, {
  fontFamily: fonts_1.mono
});
exports.xsmall = tslib_1.__assign({}, baseFont.xsmall, {
  fontFamily: fonts_1.mono
});